<template lang="pug">
div.wrap-item-object-info.px12.f.fm.flex-between.py8
  div.f.fm
    div.wrap-main-img.f.fh.mr12
      img(:src="asset.mainImg").object-fit-cover
    span.asset-name.fz14.line-clamp-2 {{asset.name}}
  div.f.fm
    v-icon(@click="onDelete" size="20" dark) mdi-delete
    //- v-menu(offset-y)
      template(v-slot:activator="{ on }")
        v-icon(v-on="on" dark) mdi-dots-vertical
      template
        div.item-object-info-more-window.px8.pt8.pb4
          div(v-for="item in moreMenuContents"
            @click="onMenu(item.label)").f.fm.mb6.cursor-pointer
            v-icon(size="20px" dark).mr6 {{item.icon}}
            span.fz14.white-space-nowrap {{item.label}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$asset_main_img_size: 52px;
.wrap-item-object-info {
  color: $dark_primary_text_color;
  border-bottom: solid 0.8px rgba(255, 255, 255, 0.4);
  width: 80vw; height: 100%;
  max-width: $studio_window_max_width;
  .wrap-main-img {
    width: $asset_main_img_size; height: $asset_main_img_size;
    border-radius: 3px;
    overflow: hidden;
    background: $primary_bg_color;
    img {
      height: 100%;
    }
  }
  .asset-name {
    max-width: 180px;
  }
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";
.item-object-info-more-window {
  background: $overlay_color;
  span {
    color: $dark_primary_text_color;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    asset: {
      type: Object,
      required: true
    },
    targetObject: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      moreMenuContents: [
        { label: '編集', icon: 'mdi-pencil' },
        { label: '削除', icon: 'mdi-delete' }
      ]
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    onMenu (label) {
      switch (label) {
        case '編集':
          this.onEdit()
          break
        case '削除':
          this.onDelete()
          break
      }
    },
    onEdit () {
      alert('編集機能は準備中です')
    },
    async onDelete () {
      const go = await window.customConfirm('削除しますか？* この操作は取り消せません')
      if (go) this.$emit('removeObject', this.targetObject)
    }
  }
}
</script>
